import { Menu } from "@headlessui/react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { CHAT_NOTIFICATION_TYPES_MEMBER_OPTIONS } from "@/react/components/Spaces/constants";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Form } from "@circle-react-uikit/Form";
import { Radio } from "@circle-react-uikit/Radio";

export interface ChatNotificationsSectionV3Props {
  notificationState: Record<string, boolean> | null;
  updateSpaceMemberNotificationPreferences: ({
    fieldKey,
  }: {
    fieldKey: string;
  }) => void;
}

export const ChatNotificationsSectionV3 = ({
  updateSpaceMemberNotificationPreferences,
  notificationState,
}: ChatNotificationsSectionV3Props) => {
  const onChange = (fieldKey: string) => {
    updateSpaceMemberNotificationPreferences({
      fieldKey,
    });
  };

  return (
    notificationState && (
      <Form defaultValues={notificationState} onSubmit={() => {}}>
        <Dropdown.Header>
          {t("space_header.my_chat_notifications")}
        </Dropdown.Header>
        {CHAT_NOTIFICATION_TYPES_MEMBER_OPTIONS.map(notificationType => (
          <Menu.Item key={notificationType.value}>
            {({ active }) => (
              <button
                type="button"
                data-testid={`${notificationType.value}`}
                className={classNames(
                  "hover:bg-tertiary text-xs-plus m-0 flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left font-medium transition-colors duration-200",
                  {
                    "bg-tertiary": active,
                  },
                )}
                onClick={() => onChange(notificationType.value)}
              >
                <Radio
                  key={notificationType.value}
                  id={`chat_space_notification_${notificationType.value}`}
                  name="chat_space_notification"
                  label={notificationType.label}
                  value={notificationType.value}
                  checked={notificationState[notificationType.value]}
                  onChange={() => onChange(notificationType.value)}
                  description={notificationType.description}
                  className="border-secondary"
                  descriptionClassName="text-xs text-default font-normal py-0.5"
                  labelClassName="text-xs-plus font-medium leading-normal mb-0"
                />
              </button>
            )}
          </Menu.Item>
        ))}
      </Form>
    )
  );
};
